import React from "react";
import * as Styled from "./Style";

const Banner = (props) => {
  return (
    <Styled.BannerStyle className={props.className}>
      <div className="icon"></div>
      <div className="details">
        <p className="title">{props.title}</p>
        <p className="body">{props.body}</p>
      </div>
    </Styled.BannerStyle>
  );
};

export default Banner;
